
import DataTableComponent2 from '@/components/DataTableComponent2.vue';
import DialogUploadFileComponent from '@/components/DialogUploadFileComponent.vue';
import { ICommunicateCreate, ICommunicateFilter, ICommunicateUpdate, ICommunicateUser } from '@/interfaces/communicate';
import { categoryStore, communicateStore, companyStore, departureStore, mainStore, roleStore } from '@/store';
import _ from 'lodash';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { Component, Vue, Watch } from 'vue-property-decorator';

// register validation rules
interface IRole {
  id: number;
  name: string;
}

interface IDeparture {
  id: number;
  name: string;
}

extend('required', {
  ...required,
  message: 'O campo {_field_} deve ser preenchido!',
});

@Component({
  components: {
    DataTableComponent2,
    ValidationObserver,
    ValidationProvider,
    DialogUploadFileComponent,
  },
})
export default class CreateCommunicate extends Vue {
  public id = 0;
  public title = '';
  public description = '';
  public paraQuem = '';
  public categoryId: null | number = null;
  public franqueadoColaborador = '';
  public isImportant = false;
  public sendEmailPF = false;
  public statesSelected: string[] = [];
  public departuresSelected: IDeparture[] = [];
  public rolesSelected: IRole[] = [];

  public listAllUsers: ICommunicateUser[] = [];
  public selectedUsers: ICommunicateUser[] = [];
  public search = '';

  get filteredUsers() {
    let users = this.listAllUsers;

    if (this.paraQuem === 'Escolas') {
      users = _.filter(users, (u) => !_.includes([1, 1069], u.company_id));
    } else if (this.paraQuem === 'Franchising') {
      users = _.filter(users, (u) => _.includes([1, 1069], u.company_id));
    }

    if (this.rolesSelected.length > 0) {
      users = _.filter(users, (u) => _.includes(_.map(this.rolesSelected, 'id'), u.role_id));
    }

    if (this.departuresSelected.length > 0) {
      users = _.filter(users, (u) => _.includes(_.map(this.departuresSelected, 'id'), u.departure_id));
    }

    if (this.statesSelected.length > 0) {
      users = _.filter(users, (u) => _.includes(_.map(this.statesSelected), u.state));
    }

    return users;
  }

  get headers() {
    const headers = [
      {
        text: 'Nome',
        sortable: true,
        value: 'name',
        align: 'left',
        type: 'varchar',
      },
      {
        text: 'Email',
        sortable: true,
        value: 'email',
        align: 'left',
        type: 'varchar',
      },
      {
        text: 'Escola',
        sortable: true,
        value: 'company_name',
        align: 'left',
        filterable: true,
        type: 'varchar',
      },
      {
        text: 'Estado',
        sortable: true,
        value: 'state',
        align: 'left',
        type: 'varchar',
      },
      {
        text: 'Cargo',
        sortable: true,
        value: 'role_name',
        align: 'left',
        type: 'varchar',
      },
      {
        text: 'Departamento',
        sortable: true,
        value: 'departure_name',
        align: 'left',
        type: 'varchar',
      },
    ];

    if (this.id) {
      headers.push({
        text: 'Lido',
        sortable: true,
        value: 'read',
        align: 'left',
        filterable: true,
        type: 'bool',
      });
    }

    return headers;
  }

  @Watch('franqueadoColaborador')
  updateFranqueadoColaborador() {
    this.rolesSelected = _.filter(this.roles, { id: 1 });
    this.departuresSelected = _.filter(this.departures, { id: 4 });
  }

  get companies() {
    return companyStore.companies;
  }

  get roles() {
    return roleStore.roles.sort((a, b) => (b.name > a.name ? -1 : 1));
  }

  get departures() {
    const departures = departureStore.departures;
    return departures.sort((a, b) => (b.name > a.name ? -1 : 1));
  }

  get currentUser() {
    return mainStore.userProfile;
  }

  get categories() {
    return _.orderBy(categoryStore.categories, 'name');
  }

  get isFranqueado() {
    return this.paraQuem.toUpperCase() == 'ESCOLAS' && this.franqueadoColaborador.toUpperCase() == 'FRANQUEADO';
  }

  isLoading = false;

  public onReset() {
    this.title = '';
    this.description = '';
  }

  public cancel() {
    this.$router.back();
  }

  public async handleSubmit() {
    // this.sendEmailPF =
    //   this.paraQuem === "Escolas" && this.franqueadoColaborador === "Franqueado"
    //     ? this.sendEmailPF
    //     : false;
    let msg = `${this.selectedUsers.length} comunicados serão enviados. <br/>`;
    if (this.isFranqueado) {
      msg += `Além disso, <b>serão disparados ${this.selectedUsers.length} e-mail(s)</b> para os franqueados!`;
    }

    await this.$swal({
      icon: 'warning',
      title: 'Tem certeza?',
      html: msg,
      showCancelButton: true,
      timer: 8000,
      timerProgressBar: true,
      confirmButtonText: 'Confirmar',
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        await this.doSubmit();
      }
    });
  }

  async doSubmit() {
    this.isLoading = true;
    if (this.id === 0) {
      let communicate = this.mountComunicado();

      const db_communicate = await communicateStore.createCommunicate(communicate);

      const el: any = this.$refs.DialogUploadFileComponent;
      if (el) {
        if (el.inputFiles.length > 0) {
          el.tableIdFromBackend == db_communicate.id;
          await el.uploadFiles(this.id || db_communicate.id);
        }
        this.$router.back();
      }
    } else {
      const communicate: ICommunicateUpdate = {
        id: this.id,
        title: this.title,
        description: this.description,
        is_important: this.isImportant,
        send_email_pf: this.sendEmailPF,
      };

      if (this.categoryId) {
        communicate.category_id = this.categoryId;
      }

      await communicateStore.updateCommunicate(communicate);
      this.isLoading = false;
      this.$router.back();
    }
    this.isImportant = false;
  }

  public mountComunicado() {
    const cargos = _.map(this.rolesSelected, 'name');
    const departamentos = _.map(this.departuresSelected, 'name');
    const users = _.map(this.selectedUsers, 'id');

    const filters: ICommunicateFilter = {
      paraQuem: this.paraQuem,
      ufs: this.statesSelected,
      fraqueadoColaborador: this.franqueadoColaborador,
      cargos: cargos,
      departamentos: departamentos,
    };
    const communicate: ICommunicateCreate = {
      title: this.title,
      description: this.description,
      filters: filters,
      users: users,
      is_important: this.isImportant,
      send_email_pf: this.sendEmailPF,
    };

    if (this.categoryId) {
      communicate.category_id = this.categoryId;
    }

    return communicate;
  }

  public async enviarPreviewEmail() {
    let communicate = this.mountComunicado();

    let res = await communicateStore.previewEmail(communicate);

    //@ts-ignore
    if (res.status == 200) {
      this.$swal({
        title: `Email enviado para ${this.currentUser?.email}`,
        icon: 'success',
        timer: 10000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
    }
  }

  public async mounted() {
    await roleStore.getRoles();
    await companyStore.getCompanies({ is_active: true });
    await communicateStore.getUsersCommunicate();
    await categoryStore.getCategories();

    this.id = parseInt(this.$router.currentRoute.params.id) || 0;

    if (this.id > 0) {
      const communicate = await communicateStore.getCommunicatesById({
        id: this.id,
      });

      this.id = communicate.id;
      this.title = communicate.title;
      this.description = communicate.description;
      this.categoryId = communicate.category_id;

      this.selectedUsers = await communicateStore.getCommunicateSendUsers({
        communicateId: communicate.id,
      });
    } else {
      this.listAllUsers = communicateStore.users;
    }
  }
}
